import * as React from 'react';
import { BreakpointSizeType } from '../../../../theme/type/breakpoints-type';
import { cn } from '../../../../utils/tailwind';

const rowMobileClass: Record<BreakpointSizeType, string> = {
    xs: 'max-xs:flex max-xs:flex-col max-xs:relative max-xs:border-b max-xs:border-dashed max-xs:border-border max-xs:p-0 max-xs:[&+&]:mt-medium',
    vs: 'max-vs:flex max-vs:flex-col max-vs:relative max-vs:border-b max-vs:border-dashed max-vs:border-border max-vs:p-0 max-vs:[&+&]:mt-medium',
    sm: 'max-sm:flex max-sm:flex-col max-sm:relative max-sm:border-b max-sm:border-dashed max-sm:border-border max-sm:p-0 max-sm:[&+&]:mt-medium',
    md: 'max-md:flex max-md:flex-col max-md:relative max-md:border-b max-md:border-dashed max-md:border-border max-md:p-0 max-md:[&+&]:mt-medium',
    lg: 'max-lg:flex max-lg:flex-col max-lg:relative max-lg:border-b max-lg:border-dashed max-lg:border-border max-lg:p-0 max-lg:[&+&]:mt-medium',
    vl: 'max-vl:flex max-vl:flex-col max-vl:relative max-vl:border-b max-vl:border-dashed max-vl:border-border max-vl:p-0 max-vl:[&+&]:mt-medium',
    xl: 'max-xl:flex max-xl:flex-col max-xl:relative max-xl:border-b max-xl:border-dashed max-xl:border-border max-xl:p-0 max-xl:[&+&]:mt-medium',
    xxl: 'max-xxl:flex max-xxl:flex-col max-xxl:relative max-xxl:border-b max-xxl:border-dashed max-xxl:border-border max-xxl:p-0 max-xxl:[&+&]:mt-medium',
    fullhd: 'max-fullhd:flex max-fullhd:flex-col max-fullhd:relative max-fullhd:border-b max-fullhd:border-dashed max-fullhd:border-border max-fullhd:p-0 max-fullhd:[&+&]:mt-medium',
};

export interface TableRowPropsInterface {
    children: React.ReactElement | React.ReactElement[];
    variant?: 'tbody' | 'thead' | 'tfoot';
    mobileBreakUnder?: BreakpointSizeType;
    isScrolled?: boolean;
    isScrollable?: boolean;
    isScrollOnEnd?: boolean;
    locked?: boolean;
    isActive?: boolean;
    borderBottom?: boolean;
    borderTop?: boolean;
    onClick?: () => void;
    className?: string;
    isSummary?: boolean;
}

export const TableRow: React.FC<TableRowPropsInterface> = ({
    children,
    variant,
    mobileBreakUnder,
    isScrolled,
    isScrollable,
    isScrollOnEnd,
    locked,
    borderBottom = true,
    borderTop,
    isActive = false,
    onClick,
    className,
    isSummary = false,
}) => {
    const rowClassName = cn(
        borderBottom && 'border-b border-solid border-border',
        borderTop && 'border-t border-solid border-[#B3B5CD]',
        isSummary && '[&>td]:border-t-[0.4rem] [&>td]:border-t-solid [&>td]:border-t-[#b3b5cd]',
        isSummary && isActive && '[&>td]:border-t-0',
        isActive &&
            '[&>td]:bg-brand-secondary/5 [&>td]:shadow-[inset_0_0.1rem_0.1rem_rgba(35,29,97,0.07)] [&>td:first-child]:rounded-l-[99rem] [&>td:last-child]:rounded-r-[99rem]',
        mobileBreakUnder && rowMobileClass[mobileBreakUnder],
        className,
    );

    if (Array.isArray(children)) {
        return (
            <tr onClick={onClick} className={rowClassName}>
                {children.map((child, index: number) => {
                    return React.cloneElement(child, {
                        variant,
                        mobileBreakUnder,
                        isScrolled,
                        isScrollable,
                        isScrollOnEnd,
                        locked,
                        ...child.props,
                        key: index,
                    });
                })}
            </tr>
        );
    }

    return (
        <tr onClick={onClick} className={rowClassName}>
            {React.cloneElement(children, {
                variant,
                isScrolled,
                isScrollable,
                isScrollOnEnd,
                locked,
                mobileBreakUnder,
                ...children.props,
            })}
        </tr>
    );
};
